// Shared date formatting — dd/mm/yyyy across all modules.
// Built manually (not toLocaleString) so the format is always zero-padded
// dd/mm/yyyy regardless of the browser locale.

type DateInput = string | number | Date | null | undefined;

function toDate(value: DateInput): Date | null {
  if (value === null || value === undefined || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** dd/mm/yyyy — e.g. 08/07/2026. Returns "—" for empty/invalid input. */
export function formatDate(value: DateInput): string {
  const d = toDate(value);
  if (!d) return "—";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${d.getFullYear()}`;
}

/** dd/mm/yyyy HH:mm (24h) — e.g. 08/07/2026 15:04. Returns "—" for empty/invalid. */
export function formatDateTime(value: DateInput): string {
  const d = toDate(value);
  if (!d) return "—";
  const hh = String(d.getHours()).padStart(2, "0");
  const min = String(d.getMinutes()).padStart(2, "0");
  return `${formatDate(d)} ${hh}:${min}`;
}
